import { render, staticRenderFns } from "./bsy-bottom.vue?vue&type=template&id=075cf4e4&scoped=true&"
import script from "./bsy-bottom.vue?vue&type=script&lang=js&"
export * from "./bsy-bottom.vue?vue&type=script&lang=js&"
import style0 from "./bsy-bottom.vue?vue&type=style&index=0&id=075cf4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075cf4e4",
  null
  
)

export default component.exports